import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Thdata from '../entities/thdata'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface ThdataState extends ListState<Thdata> {
    analyseThdata: Thdata
}
class UserMutations extends ListMutations<Thdata>{

}
class ThdataModule extends ListModule<ThdataState, any, Thdata>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Thdata>(),
        loading: false,
        analyseThdata: new Thdata()
    }
    actions = {

        async getPaged(context: ActionContext<ThdataState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetPaged', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getPagedLast(context: ActionContext<ThdataState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        async getPagedReal(context: ActionContext<ThdataState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetRealPaged', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getThisThPaged(context: ActionContext<ThdataState, any>, payload: any) {

            let reponse = await Ajax.get('//api/services/app/ThData/GetThisTHPaged', { params: payload.data });
            return reponse.data.result.items;

            // context.state.loading = true;
            // let reponse = await Ajax.get('/api/services/app/ThData/GetThisTHPaged', { params: payload.data });
            // context.state.loading = false;
            // let page = reponse.data.result as PageResult<Thdata>;
            // context.state.totalCount = page.totalCount;
            // context.state.list = page.items;
        },
        async getWarningPaged(context: ActionContext<ThdataState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetWarningPaged', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async GetOffWarningPaged(context: ActionContext<ThdataState, any>, payload: any) {

            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetOffWarningPaged', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getEleWarningPaged(context: ActionContext<ThdataState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetEleWarningPaged', { params: payload.data });
            context.state.loading = false;
            context.state.totalCount = reponse.data.result.totalCount;
            context.state.list = reponse.data.result.items;
        },
        async get(context: ActionContext<ThdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThData/GetById?Id=' + payload.id);
            return reponse.data.result as Thdata;
        },
        async getWarning(context: ActionContext<ThdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThData/GetWarningList');
            return reponse.data.result.items;
        },
        async getRank(context: ActionContext<ThdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThData/GetRankList?day=' + payload.data);
            return reponse.data.result.items;
        },
        async exportExcelsummary(context: ActionContext<ThdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThData/ExportExcelsummary', { params: payload.data });
            return reponse;
        },
        async getLostDataList(context: ActionContext<ThdataState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetLostDataList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
            return 1;
        },
        async getLostData(context: ActionContext<ThdataState, any>, payload: any) {
            // context.state.loading=true;
            let reponse = await Ajax.get('/api/services/app/ThData/GetLostData', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Thdata>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
            return page.items;
        },
        async getPageByDate(context: ActionContext<ThdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThData/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Thdata>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items; 6aba6214f15918e1bc4225e3ea66df430b9fbce7
            return page.items;
        }

    };
    mutations = {
        setCurrentPage(state: ThdataState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ThdataState, pagesize: number) {
            state.pageSize = pagesize;
        },
        analyse(state: ThdataState, thdata: Thdata) {
            state.analyseThdata = thdata;
        },
        lostanalyse(state: ThdataState, thdata: Thdata) {
            state.analyseThdata = thdata;
        }
    }
}
const thdataModule = new ThdataModule();
export default thdataModule;